import { render, staticRenderFns } from "./CreateTypologySize.vue?vue&type=template&id=e0c9ce5c&scoped=true&"
import script from "./CreateTypologySize.vue?vue&type=script&lang=js&"
export * from "./CreateTypologySize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0c9ce5c",
  null
  
)

export default component.exports